const DEFAULT_SCENE = 'requests';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;
const HEADER_SEARCH_REQUESTS = `${DEFAULT_SCENE}:filter-agent`;

const LIST = `${DEFAULT_SCENE}:list`;
export const LIST_CONTAINER_TAG = `${LIST}:container`;
export const getListItemTag = (propName: string) => `${LIST}:request-${propName}`;

export const LIST_PAGINATION_TAG = `${LIST}:pagination`;

export const EMAIL_NOTIFICATION_SWITCH_TAG = `${DEFAULT_SCENE}:email-notifications:switch`;

// Header Search
export const SEARCH_REQUESTS_CONTAINER_TAG = `${HEADER_SEARCH_REQUESTS}:container`;
export const SEARCH_REQUESTS_SUBMIT_BUTTON_TAG = `${HEADER_SEARCH_REQUESTS}:button-submit`;

// SideBar Filter
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;
export const TO_DEFAULT_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:to-default-all-filters`;

export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;
